import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'
import VueTour from 'vue-tour'

import router from './router'
import store from './store'
import { Auth0Plugin } from './auth'
import NearPlugin from './plugins/near.plugin'
import GhostPlugin from './plugins/ghost.plugin'
import BackendPlugin from './plugins/backend'
import { utils } from 'near-api-js';

global.tld = document.domain.match(/[^.]*.com/)[0];

require('vue-tour/dist/vue-tour.css')

Vue.filter('formatNearAmount', function(amount) {
    if (!amount) return '';
    const formatted = utils.format.formatNearAmount(amount);
    return formatted.length <= 5 ? formatted : parseFloat(formatted).toExponential();
});
Vue.filter('bra', function(size) {
	const { band, cup } = size;
    if (!size) return '';
    return `${band}${cup.toUpperCase()}`
});
Vue.filter('plural', function(name) {
	return name && name.endsWith('s') ? `${name}'` ? name.endsWith('S') : `${name}'S` : `${name}'s`;
});
Vue.filter('hyperlink', function(text) {
	if (!text) return;
	const matches = text.matchAll(/(https?:\/\/[^\s\/]*\/[^\s\/?]*)[^\s]*/g);
	for (let match of matches) {
		const url = match[0]
		const domain = match[1];
		text = text.replace(url, `<a style="text-decoration: none" href="${url}" target="_blank" rel="noopener">${domain}...</a>`);
	}
	return text;
});

Vue.use(Auth0Plugin, {
	domain: process.env.VUE_APP_AUTH0_DOMAIN,
	clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
	audience: process.env.VUE_APP_AUTH0_AUDIENCE,
	onRedirectCallback: (appState) => {
		router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname)
	},
})
Vue.use(NearPlugin)
Vue.use(GhostPlugin)
Vue.use(BackendPlugin)
Vue.use(NearPlugin)
Vue.use(VueCookies)
Vue.use(VueTour)

Vue.config.productionTip = false

const vm = new Vue({
	store,
	vuetify,
	router,
	render: (h) => h(App),
})

Vue.mixin({
	computed: {
		$mobile: () => vm.$vuetify.breakpoint.mobile
	}
})

window.onload = function () {
	vm.$mount('#app')
}
